// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'
import { getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB5QUhzpal7NRzQLz_oAqv4MDrgnjTe750",
  authDomain: "contratos-abiertos-bd.firebaseapp.com",
  projectId: "contratos-abiertos-bd",
  storageBucket: "contratos-abiertos-bd.firebasestorage.app",
  messagingSenderId: "67037646720",
  appId: "1:67037646720:web:3373a7c6babee0a1633b65",
  measurementId: "G-J19V0MSFJY"
};
const app = initializeApp(firebaseConfig)

const database = getDatabase(app)
const storage = getStorage(app)

export { database, storage }


// src/lib/firebase.js



